<template>
    <div class="pa-4">
        <v-list two-line>
            <v-list-item-group color="zoezi-edit-color" mandatory v-model="currentRevision">
                <v-list-item
                    v-for="item in revisions"
                    :key="item.id"
                    @click="loadRevision(item.id)"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{item.time}} (version {{item.id}})</v-list-item-title>
                        <v-list-item-subtitle>{{item.author}}</v-list-item-subtitle>
                    </v-list-item-content>

                </v-list-item>
            </v-list-item-group>
        </v-list>

        <v-btn v-if="truncateAt" color="zoezi-edit-color" @click="truncateAt = null">
            {{$translate('Load more versions')}}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'RevisionHistory',
    components: {
    },
    data: () => ({
        allRevisions: [],
        currentRevision: 0,
        truncateAt: 50
    }),
    watch: {
        '$root.revisionPreview'() {
            this.currentRevision = this.$root.revisionPreview ? this.revisions.findIndex(rev => rev.id == this.$root.revisionPreview.id) : 0;
        }
    },
    computed: {
        revisions() {
            return this.truncateAt ? this.allRevisions.slice(0, this.truncateAt) : this.allRevisions;
        }
    },
    methods: {
        getRevisions() {
            this.$api.get('/api/homepage/revision/get', {homepage_id: this.$root.homepage_id}).then(data => {
                this.allRevisions = data.map(item => ({id: item.id, time: item.created, author: item.author}));
            })
        },
        loadRevision(id) {
            if (id == this.$root.current_revision_id) {
                this.$root.revisionPreview = null
            } else {
                this.$root.revisionPreview = this.revisions.find(rev => rev.id == id);
            }
        }
    },
    mounted() {
        this.getRevisions();
    }
}
</script>
